<div class="search">
  <div class="container">
    <form method="get" id="searchform" action="">
      <label class="label">Buscar por Módulos: </label>
      <input
        placeholder="Digite aqui para pesquisar"
        #input
        (input)="update.emit(input.value)"
      />
      <button type="submit"><i class="fa fa-search"></i></button>
    </form>
  </div>
</div>
